export const MessageChannel = {
  SMS: 'sms',
} as const;

export type MessageChannelType = (typeof MessageChannel)[keyof typeof MessageChannel];
